import React, { useState } from 'react';
import Moment from 'moment';
import { Row, Col, Button, Card, CardBody, CardHeader, Collapse, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";

const CertificationStatus = ({ summary, isWizardCompleted, wizardDetails, handleWizardChanged, certificationAndAuditStatus }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [isIconUp, setIsIconUp] = useState(true);
    const roleName = localStorage.getItem("roleName");
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    const [itemDeletePopup, setItemDeletePopup] = useState({ showItemDeletePopup: false, section: '' });
    const handleItemDeletePopupClose = () => {
        setItemDeletePopup({ showItemDeletePopup: false });
    }
    const handleItemDeletePopupConfirm = () => {
        setItemDeletePopup({ showItemDeletePopup: false });
        handleWizardChanged(itemDeletePopup.section);
    }
    const handleItemDeletePopupOpen = (Section) => {
        setItemDeletePopup({ showItemDeletePopup: true, section: Section });
    }

    const CustomToastWithLink = () => (
        <div>
            <p>If you upload a certification report or audit report these can then generate a status for your farm Once your plan is certified you can switch to Operation by clicking on this button. At that point, you may no longer delete an action, only close it.</p>
        </div>
    );
    const customId = "custom-id-yes";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };
    return (
        <>
         <Card className="my-4">
            <CardHeader className="card-header-dark-click" onClick={toggle}>
                <Row>
                        <Col sm="11"><h5>Certification & Audit Status&nbsp;&nbsp;&nbsp;
                            <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-35" onClick={(e) => e.stopPropagation()} />
                        </h5>
                            <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                id="my-tooltip-35"
                                place="top"
                                variant="info"
                                render={({ content, activeAnchor }) => (
                                    <>
                                        <Row>
                                            <Col>
                                                <p style={{ fontWeight: "lighter" }}>
                                                    For more information on Certification and Audit status <a href="https://freshwaterfarmplan.co.nz/fwfp-support/certification-and-audit-status/" target="_blank" rel="noreferrer">Click Here</a>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            />
                        </Col>
                    <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                </Row>
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody>
                    <Row>
                    </Row>
                    <Row>
                        <Col sm="12">
                            {!isWizardCompleted ?
                                <div className="progress-bar bg-warning completeBar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" >
                                    Not yet submitted – in progress (Draft mode)
                                </div>
                                :
                                <>
                                    {isWizardCompleted && !certificationAndAuditStatus.isAudited && !certificationAndAuditStatus.isCertified ?
                                        <>
                                            <div className="progress-bar bg-success completeBar" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" >
                                                {wizardDetails.status} <br /> submitted by {wizardDetails.updatedBy} on {Moment(wizardDetails.statusUpdatedDate).format('DD/MM/YYYY')}
                                            </div>
                                            <div className="form-label-submitted-text" style={{ marginTop: '10px' }}>
                                                FWFP has not yet been certified or audited
                                            </div>
                                        </>
                                        :
                                        <>
                                            {certificationAndAuditStatus.isCertified &&
                                                <div className="progress-bar bg-success completeBar" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" >
                                                    {certificationAndAuditStatus.certificationNotes}
                                                </div>
                                            }
                                            {certificationAndAuditStatus.isAudited &&
                                                <>
                                                    <br />
                                                    <div className="progress-bar bg-info completeBar" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" >
                                                        {certificationAndAuditStatus.auditNotes}
                                                    </div>
                                                </>
                                            }
                                        </>
                                    }
                                </>

                            }
                        </Col>

                    </Row>
                    <Row>
                        <Col>
                            {/*{(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&*/}
                            {/*    <>*/}
                            {/*    {isWizardCompleted != true &&*/}
                            {/*            <Col><Button color="success" className="btn-sm summary-submit-button" onClick={(section) => handleItemDeletePopupOpen(summary.Section)}> Save and Submit</Button></Col>*/}
                            {/*    }*/}
                            {/*    </>*/}
                            {/*}*/}
                        </Col>

                    </Row>
                </CardBody>
            </Collapse>
            </Card>
            <Modal size="lg" style={{ maxWidth: '1000px', width: '100%' }} isOpen={itemDeletePopup.showItemDeletePopup}>
                <ModalHeader toggle={handleItemDeletePopupClose} >Confirm</ModalHeader>
                <ModalBody>
                   {/* This will switch the Freshwater Farm Plan from DRAFT mode to OPERATIONAL. This change will adjust the menu layout from a step-by-step wizard to a more logical layout aligned with managing the Freshwater Farm Plan instead of building it. It also applies business rules around actions where they can no longer be deleted and need to be validated by closing instead. All other aspects the Freshwater Farm Plan remain the same and users can still add new infrastrure, add actions, close actions, and other areas system can continue to be edited.*/}
                    The Freshwater Farm Plan is being submitted for review. All other aspects the Freshwater Farm Plan remain the same and users can still add new infrastrure, add actions, close actions, and other areas system can continue to be edited.
                    Are you sure you wish to continue?
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleItemDeletePopupConfirm} color="primary">
                        Yes
                    </Button>{' '}
                    <Button color="danger" onClick={handleItemDeletePopupClose}>No</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
export default CertificationStatus